/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput';
import { Provider } from '../models/Provider';

export class AccountConfigInput {
  'cloudProvider': Provider;
  'aws'?: AwsAccountConfigInput | null;
  'azure'?: AzureAccountConfigInput | null;
  'gcp'?: GcpAccountConfigInput | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsAccountConfigInput",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureAccountConfigInput",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpAccountConfigInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccountConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}



